// src/services/socket.js
import { io } from "socket.io-client";
import { NODE_HOST } from "../config/siteUrls";
let socketInstance = null;

export const initializeSocket = (accessToken, userId, schoolId, userName) => {
  if (!socketInstance) {
    socketInstance = io(NODE_HOST, {
      auth: {
        token: accessToken,
      },
    });

    // Emit join event after connection
    socketInstance.on("connect", () => {
      socketInstance.emit("joinSchool", {
        schoolId,
        userId,
        userName,
      });
    });
  }

  return socketInstance;
};

export const getSocket = () => socketInstance;

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};
